import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
// Self-hosted, so the CSP can stay font-src 'self' and nothing loads from Google.
import "@fontsource-variable/figtree";
import "./styles/tokens.css";
import "./styles/app.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/*
 * The service worker is what makes this installable (public/sw.js). It is
 * registered after load so it never competes with the first paint, and not at
 * all in development, where a cached shell is only ever confusing.
 */
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
